import { useEffect, useRef } from "react";
import cloudinary from "cloudinary-video-player";
import "cloudinary-video-player/chapters";
import "cloudinary-video-player/cld-video-player.min.css";
import { PlayerWrapper } from "./styled";

const VideoPlayer = ({
  src,
  captions,
  subtitles,
  chaptersUrl,
  onPlayButtonClick,
  poster,
  ...props
}) => {
  const cloudinaryRef = useRef();
  const playerRef = useRef();

  // Initialize the player only once
  useEffect(() => {
    if (!cloudinaryRef.current) {
      cloudinaryRef.current = cloudinary;

      // Create the Cloudinary player instance
      const player = cloudinaryRef.current.videoPlayer(playerRef.current, {
        showCaptionsButton: captions || subtitles,
        textTrackSettings: true,
        controls: true,
        showLogo: false,
        hideContextMenu: true,
        pictureInPictureToggle: true,
        playbackRates: [2, 1.75, 1.5, 1.25, 1, 0.75, 0.5, 0.25],
        fill: true,
      });

      // Store the player instance
      cloudinaryRef.current.playerInstance = player;
    }
  }, [captions, subtitles]);

  // Update the video source and related properties dynamically when the video changes
  useEffect(() => {
    if (cloudinaryRef.current?.playerInstance) {
      const player = cloudinaryRef.current?.playerInstance;

      // Prepare text tracks for captions and subtitles
      const textTracks = {};
      if (captions) {
        textTracks.captions = captions;
      }
      if (subtitles) {
        textTracks.subtitles = subtitles;
      }

      // Update the source without recreating the player
      player.source(src, {
        sourceTypes: ["mp4"],
        poster,
        chapters: chaptersUrl && {
          url: chaptersUrl,
        },
        textTracks,
      });
    }
  }, [src, captions, subtitles, chaptersUrl, poster]);

  return (
    <PlayerWrapper>
      <video
        ref={playerRef}
        data-testid="cloudinary-video-player"
        className="cld-video-player"
        onPlay={() => {
          if (onPlayButtonClick) {
            onPlayButtonClick();
          }
        }}
        {...props}
      />
    </PlayerWrapper>
  );
};

export default VideoPlayer;
